import { fallConfig } from './fall/fall-config';
import { ACTIVE_SEASON, Season } from './seasonal-config';
import { springConfig } from './spring/spring-config';
import { summerConfig } from './summer/summer-config';
import { SeasonConfig } from './types';
import { winterConfig } from './winter/winter-config';

/**
 * Get the configuration for the currently active season
 * This centralizes all season-specific assets, colors, and components
 */
export const getSeasonConfig = (): SeasonConfig => {
	switch (ACTIVE_SEASON) {
		case Season.FALL:
			return fallConfig;
		case Season.WINTER:
			return winterConfig;
		case Season.SPRING:
			return springConfig;
		case Season.SUMMER:
			return summerConfig;
		default:
			return fallConfig;
	}
};
